/**
 * @author Omar Sánchez Martínez
 * @since 20/08/2025
 * @description FacturaType enum with Spanish conversion methods
 */

export enum FacturaType {
  EGRESO = 'E',
  INGRESO = 'I',
  TRASLADO = 'T',
  PAGO = 'P',
  GLOBAL = 'G',
}

/**
 * @author Omar Sánchez Martínez
 * @since 20/08/2025
 * @description Converts FacturaType enum value to Spanish display text
 */
export const facturaTypeToSpanish = (type: FacturaType): string => {
  const typeMap: Record<FacturaType, string> = {
    [FacturaType.EGRESO]: 'Egreso',
    [FacturaType.INGRESO]: 'Ingreso',
    [FacturaType.TRASLADO]: 'Traslado',
    [FacturaType.PAGO]: 'Pago',
    [FacturaType.GLOBAL]: 'Global',
  };

  return typeMap[type] || type;
};

/**
 * @author Omar Sánchez Martínez
 * @since 20/08/2025
 * @description Converts FacturaType enum value to Spanish slug (for CSS classes, etc.)
 */
export const facturaTypeToSpanishSlug = (type: FacturaType): string => {
  const typeMap: Record<FacturaType, string> = {
    [FacturaType.EGRESO]: 'egreso',
    [FacturaType.INGRESO]: 'ingreso',
    [FacturaType.TRASLADO]: 'traslado',
    [FacturaType.PAGO]: 'pago',
    [FacturaType.GLOBAL]: 'global',
  };

  return typeMap[type] || type;
};

/**
 * @author Omar Sánchez Martínez
 * @since 20/08/2025
 * @description Gets the appropriate CSS class for FacturaType (for styling)
 */
export const facturaTypeToCssClass = (type: FacturaType): string => {
  const typeMap: Record<FacturaType, string> = {
    [FacturaType.EGRESO]: 'type-egreso',
    [FacturaType.INGRESO]: 'type-ingreso',
    [FacturaType.TRASLADO]: 'type-traslado',
    [FacturaType.PAGO]: 'type-pago',
    [FacturaType.GLOBAL]: 'type-global',
  };

  return typeMap[type] || 'type-default';
};

/**
 * @author Omar Sánchez Martínez
 * @since 20/08/2025
 * @description Converts FacturaType enum value to Spanish display text
 */
export const facturaTypeToText = (type: FacturaType): string => {
  const typeMap: Record<FacturaType, string> = {
    [FacturaType.EGRESO]: 'Factura de Egreso',
    [FacturaType.INGRESO]: 'Factura',
    [FacturaType.TRASLADO]: 'Traslado',
    [FacturaType.PAGO]: 'Pago',
    [FacturaType.GLOBAL]: 'Factura Global',
  };

  return typeMap[type] || type;
};
